export const Chip = ({ selected, onClick, children, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className={`rounded-full px-5 py-2.5 text-sm font-semibold border transition-all duration-300 ${
      selected
        ? "bg-terracotta text-cream border-terracotta scale-[1.03] shadow-[0_8px_20px_rgba(192,87,70,0.3)]"
        : "bg-cream border-ochre/40 text-earth hover:border-terracotta"
    }`}
  >
    {children}
  </button>
);

export const StepProgress = ({ step, total }) => (
  <div className="mb-10" data-testid="form-progress">
    <div className="flex items-center justify-between mb-3">
      <p className="text-xs uppercase tracking-[0.25em] font-bold text-terracotta">
        Step {step} of {total}
      </p>
      <div className="flex gap-2">
        {Array.from({ length: total }).map((_, i) => (
          <span
            key={i}
            className={`h-2 rounded-full transition-all duration-500 ${i < step ? "bg-terracotta w-8" : "bg-ochre/30 w-2"}`}
          />
        ))}
      </div>
    </div>
    <div className="h-1.5 rounded-full bg-ochre/20 overflow-hidden">
      <div
        className="h-full bg-terracotta rounded-full transition-all duration-700"
        style={{ width: `${(step / total) * 100}%` }}
      />
    </div>
  </div>
);

export const StepNav = ({ onBack, onNext, nextLabel = "Continue", busy, isLast, showBack = true }) => (
  <div className="mt-10 flex flex-wrap items-center gap-4">
    {showBack && onBack && (
      <button
        type="button"
        data-testid="form-back-btn"
        onClick={onBack}
        className="rounded-full border-2 border-charcoal px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-charcoal transition-colors hover:bg-charcoal hover:text-cream"
      >
        Back
      </button>
    )}
    <button
      type="button"
      data-testid="form-next-btn"
      onClick={onNext}
      disabled={busy}
      className="rounded-full bg-terracotta px-10 py-4 text-sm font-bold uppercase tracking-widest text-cream transition-all duration-300 hover:scale-[1.04] hover:bg-earth disabled:opacity-60 disabled:hover:scale-100"
    >
      {busy ? "Sending…" : nextLabel}
    </button>
  </div>
);
